import * as React from 'react';

const styles = require('./styles.css');

interface INewbuildingConsultantPhoneProps {
  phone: string;
}

export function NewbuildingConsultantPhone({ phone }: INewbuildingConsultantPhoneProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['work-time']}>Консультация с 09:00 до 18:00</div>
      <div className={styles['phone']}>{phone}</div>
    </div>
  );
}
